const data = {
  // 违规处理
  wgcl: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'address',
      label: '位置',
      width: '250'
    }, {
      prop: 'brandIds',
      label: '品牌',
      width: '100'
    }, {
      prop: 'memo',
      label: '描述',
      width: '300'
    }, {
      prop: 'accuseTypes',
      label: '类型',
      width: '350'
    }, {
      prop: 'submitName',
      label: '提交人',
      width: '120'
    }, {
      prop: 'submitWorkOrgan',
      label: '工作单位',
      width: '120'
    }, {
      prop: 'createTime',
      label: '创建时间',
      width: '180'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  },
  xtkh: { // 系统考核
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '100',
      fix: 'left'
    }, {
      prop: 'gpsAddr',
      label: '位置',
      width: '250',
      fix: 'left'
    }, {
      prop: 'workId',
      label: '任务编码',
      width: '200'
    },{
      prop: 'brandIds',
      label: '品牌',
      width: '90'
    }, {
      prop: 'mold',
      label: '任务类型',
      width: '120'
    }, {
      prop: 'createTime',
      label: '创建时间',
      width: '190'
    }, {
      prop: 'respondStatus',
      label: '响应状态',
      width: '100',
      slot: 'respondStatus'
    }, {
      prop: 'completeStatus',
      label: '完成状态',
      width: '100',
      slot: 'completeStatus'
    }, {
      prop: 'respondDatetime',
      label: '处理时间',
      width: '100',
      slot: 'respondTime'
    }, {
      prop: 'Timeout',
      label: '超时时长',
      width: '100',
      slot: 'TimeoutTime'
    }, {
      prop: 'respondDatetimeTimeout',
      label: '超时日期',
      width: '180'
    }, {
      prop: 'completeDatetime',
      label: '完成日期',
      width: '180'
    }, {
      prop: 'siteId',
      label: '站点编号',
      width: '140'
    }, {
      prop: 'bikeId',
      label: '车辆编号',
      width: '120'
    }]
  },
  rgkh: { // 人工考核
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'address',
      label: '位置',
      width: '250'
    }, {
      prop: 'brandIds',
      label: '品牌',
      width: '100'
    }, {
      prop: 'memo',
      label: '描述',
      width: '300'
    }, {
      prop: 'examineInfo',
      label: '分类',
      width: '350'
    }, {
      prop: 'reportName',
      label: '提交人',
      width: '120'
    }, {
      prop: 'finishTime',
      label: '整改时长',
      width: '120'
    }, {
      prop: 'createTime',
      label: '创建时间',
      width: '180'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  },
  // 品牌报表
  brandsList: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'title',
      label: '类型名称',
      width: '250'
    }, {
      prop: 'total',
      label: '违规次数',
      width: '100'
    }, {
      prop: 'dealTotal',
      label: '已处理',
      width: '100'
    }, {
      prop: 'notDealTotal',
      label: '未处理',
      width: '100'
    }, {
      prop: 'timelyTotal',
      label: '及时处理',
      width: '100'
    }, {
      prop: 'notTimelyTotal',
      label: '超时处理',
      width: '100'
    }, {
      prop: 'timelyTotal',
      label: '处理及时率',
      width: '180'
    }, {
      prop: 'passTotal',
      label: '合格率',
      width: '180'
    }]
  },
  // 违规类型设置
  wglxsz: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'title',
      label: '类型名称'
    }, {
      prop: 'sort',
      label: '排序'
    }, {
      fix: 'right',
      label: '操作'
    }]
  },
  // 站点申请 - 审核
  zdsq_sh: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '200'
    }, {
      prop: 'address',
      label: '位置',
      width: '250'
    }, {
      prop: 'realname',
      label: '申请人',
      width: '150'
    }, {
      prop: 'workOrgan',
      label: '单位',
      width: '150'
    }, {
      prop: 'createTime',
      label: '申请时间',
      width: '180'
    }, {
      prop: 'status',
      label: '状态',
      width: '150'
    }, {
      prop: 'checkUserName',
      label: '审核人',
      width: '150'
    }, {
      prop: 'checkTime',
      label: '审核时间',
      width: '180'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  },
  // 站点申请 - 画线
  zdsq_hx: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '150'
    }, {
      prop: 'address',
      label: '位置',
      width: '250'
    }, {
      prop: 'checkUserName',
      label: '审核人',
      width: '150'
    }, {
      prop: 'workOrgan',
      label: '单位',
      width: '300'
    }, {
      prop: 'checkTime',
      label: '审核时间',
      width: '180'
    }, {
      prop: 'status',
      label: '状态',
      width: '150'
    }, {
      prop: 'drawUserName',
      label: '画线人',
      width: '150'
    }, {
      prop: 'drawTime',
      label: '画线时间',
      width: '180'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  },
  // 站点申请 - 安装
  zdsq_az: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '200'
    }, {
      prop: 'address',
      label: '位置',
      width: '250'
    }, {
      prop: 'drawUserName',
      label: '画线人',
      width: '250'
    }, {
      prop: 'workOrgan',
      label: '单位',
      width: '150'
    }, {
      prop: 'drawTime',
      label: '画线时间',
      width: '180'
    }, {
      prop: 'status',
      label: '状态',
      width: '150'
    }, {
      prop: 'installUserName',
      label: '安装人',
      width: '150'
    }, {
      prop: 'installTime',
      label: '安装时间',
      width: '180'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  },
  // 站点申请 - 已拒绝
  zdsq_jj: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '200'
    }, {
      prop: 'address',
      label: '位置',
      width: '250'
    }, {
      prop: 'realname',
      label: '申请人',
      width: '150'
    }, {
      prop: 'workOrgan',
      label: '单位',
      width: '150'
    }, {
      prop: 'createTime',
      label: '申请时间',
      width: '180'
    }, {
      prop: 'status',
      label: '状态',
      width: '150'
    }, {
      prop: 'checkUserName',
      label: '审核人',
      width: '150'
    }, {
      prop: 'checkTime',
      label: '审核时间',
      width: '180'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  },
  // 站点申请 - 不可画线
  zdsq_bkhx: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '200'
    }, {
      prop: 'address',
      label: '位置',
      width: '250'
    }, {
      prop: 'checkUserName',
      label: '审核人',
      width: '150'
    }, {
      prop: 'workOrgan',
      label: '单位',
      width: '150'
    }, {
      prop: 'checkTime',
      label: '审核时间',
      width: '180'
    }, {
      prop: 'status',
      label: '状态',
      width: '150'
    }, {
      prop: 'drawUserName',
      label: '画线人',
      width: '150'
    }, {
      prop: 'drawTime',
      label: '画线时间',
      width: '180'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  },
  // 角色管理 - 站点角色
  jsgl_zdjs: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'name',
      label: '姓名',
      width: '150'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '200'
    }, {
      prop: 'maintainGroup',
      label: '角色',
      width: '150'
    }, {
      prop: 'nickname',
      label: '微信昵称',
      width: '150'
    }, {
      prop: 'phone',
      label: '手机号码',
      width: '150'
    }, {
      prop: 'workOrgan',
      label: '工作单位',
      width: '250'
    },
    {
      fix: 'right',
      label: '操作',
      width: '100'
    }
    ]
  },
  // 角色管理 - 运维员
  jsgl_ywy: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'name',
      label: '姓名',
      width: '150'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '200'
    }, {
      prop: 'phone',
      label: '手机号码',
      width: '150'
    }, {
      prop: 'brandId',
      label: '品牌公司',
      width: '150'
    },
    {
      fix: 'right',
      label: '操作',
      width: '100'
    }
    ]
  },
  // 角色管理 - 监管员
  jsgl_jgy: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'name',
      label: '姓名',
      width: '150'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '200'
    }, {
      prop: 'phone',
      label: '手机号码',
      width: '150'
    }, {
      prop: 'workOrgan',
      label: '工作单位',
      width: '150'
    },
    {
      fix: 'right',
      label: '操作',
      width: '100'
    }
    ]
  },
  // 审核列表 - 站点管理
  shlb_zdgl: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '200'
    }, {
      prop: 'name',
      label: '姓名',
      width: '150'
    }, {
      prop: 'group',
      label: '角色',
      width: '150'
    }, {
      prop: 'nickname',
      label: '微信昵称',
      width: '150'
    }, {
      prop: 'phone',
      label: '手机号码',
      width: '150'
    }, {
      prop: 'workOrgan',
      label: '工作单位',
      width: '150'
    }, {
      prop: 'applyStatus',
      label: '审核状态',
      width: '120'
    }, {
      prop: 'createTime',
      label: '申请时间',
      width: '180'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  },
  // 审核列表 - 调度员
  shlb_duy: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'name',
      label: '姓名',
      width: '150'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '200'
    }, {
      prop: 'phone',
      label: '手机号码',
      width: '150'
    }, {
      prop: 'brandId',
      label: '品牌公司',
      width: '150'
    }, {
      prop: 'applyStatus',
      label: '审核状态',
      width: '150'
    }, {
      prop: 'createTime',
      label: '申请时间',
      width: '200'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  },
  // 审核列表 - 调度员
  shlb_jgy: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'name',
      label: '姓名',
      width: '150'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '200'
    }, {
      prop: 'phone',
      label: '手机号码',
      width: '150'
    }, {
      prop: 'workOrgan',
      label: '工作单位',
      width: '150'
    }, {
      prop: 'applyStatus',
      label: '审核状态',
      width: '150'
    }, {
      prop: 'createTime',
      label: '申请时间',
      width: '200'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  },
  // 公告通知
  ggtz: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'regionId',
      label: '地区',
      width: '200'
    }, {
      prop: 'title',
      label: '公告标题',
      width: '300'
    }, {
      prop: 'userName',
      label: '创建者',
      width: '150'
    }, {
      prop: 'createTime',
      label: '创建时间',
      width: '200'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  },
  // 调度记录
  ddjl: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'bikeId',
      label: '车辆编号',
      width: '150'
    }, {
      prop: 'brandId',
      label: '品牌',
      width: '150'
    }, {
      prop: 'startSite',
      label: '起始站点',
      width: '350'
    }, {
      prop: 'endSite',
      label: '结束站点',
      width: '350'
    }, {
      fix: 'right',
      prop: 'startUserName',
      label: '运维员',
      width: '150'
    }]
  },
  // 未传车辆匹配成功
  wccl: {
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'bikeId',
      label: '车辆编号',
      width: '150'
    }, {
      prop: 'miUserName',
      label: '操作人',
      width: '150'
    }, {
      prop: 'createTime',
      label: '入库时间',
      width: '200'
    }, {
      prop: 'brandName',
      label: '车企',
      width: '150'
    }, {
      prop: 'matchStatus',
      label: '匹配状态',
      width: '150'
    }, {
      prop: 'matchTime',
      label: '最终匹配时间',
      width: '200'
    }, {
      fix: 'right',
      label: '操作',
      width: '150'
    }]
  },
  // 多命中
  wccl_dmz: {
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'bikeId',
      label: '车辆编号',
      width: '150'
    }, {
      prop: 'miUserName',
      label: '操作人',
      width: '150'
    }, {
      prop: 'createTime',
      label: '入库时间',
      width: '200'
    }, {
      prop: 'brandName',
      label: '车企',
      width: '150'
    }, {
      fix: 'right',
      label: '操作',
      width: '150'
    }]
  },
  // 未命中
  wccl_wmz: {
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'bikeId',
      label: '车辆编号',
      width: '150'
    }, {
      prop: 'miUserName',
      label: '操作人',
      width: '150'
    }, {
      prop: 'createTime',
      label: '入库时间',
      width: '200'
    }, {
      prop: 'brandName',
      label: '车企',
      width: '150'
    }, {
      fix: 'right',
      label: '操作',
      width: '150'
    }]
  },
  // 匹配规则
  ppgz: {
    columns: [{
      prop: 'brandName',
      label: '车企',
      width: '150'
    },
    {
      prop: 'bikeIdPrefix',
      label: '编码前缀',
      width: '150'
    }, {
      prop: 'bikeIdLength',
      label: '编码位数',
      width: '150'
    }, {
      prop: 'createTime',
      label: '创建时间',
      width: '200'
    }, {
      prop: 'updateTime',
      label: '修改时间',
      width: '200'
    },
    {
      fix: 'right',
      label: '操作',
      width: '150'
    }]
  },
  xtppgz: {
    columns: [{
      prop: 'brandName',
      label: '品牌',
      width: '150'
    },
    {
      prop: 'namePrefix',
      label: 'name前缀',
      width: '150'
    }, {
      prop: 'nameLength',
      label: 'name位数',
      width: '150'
    }, {
      prop: 'bikeIdExtractStart',
      label: '编码起始位置',
      width: '150'
    }, {
      prop: 'bikeIdExtractLength',
      label: '编码截取长度',
      width: '150'
    }, {
      prop: 'createTime',
      label: '创建时间',
      width: '200'
    }, {
      prop: 'updateTime',
      label: '修改时间',
      width: '200'
    },
    {
      fix: 'right',
      label: '操作',
      width: '150'
    }]
  },
  xt_ppcg:{
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'bikeMac',
      label: '车辆MAC',
      width: '150'
    }, {
      prop: 'miUserName',
      label: '操作人',
      width: '100'
    }, {
      prop: 'createTime',
      label: '入库时间',
      width: '200'
    },{
      prop: 'bleName',
      label: '广播name',
      width: '150'
    },{
      prop: 'bleRssi',
      label: 'RSSI值',
      width: '150'
    },{
      prop: 'bikeId',
      label: '车辆编号',
      width: '150'
    }, {
      prop: 'brandName',
      label: '车企',
      width: '150'
    }, {
      prop: 'matchStatus',
      label: '匹配状态',
      width: '150'
    }, {
      prop: 'matchTime',
      label: '最终匹配时间',
      width: '200'
    }, {
      fix: 'right',
      label: '操作',
      width: '150'
    }]
  },
  xt_dmz:{
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'bikeMac',
      label: '车辆MAC',
      width: '150'
    }, {
      prop: 'miUserName',
      label: '操作人',
      width: '100'
    }, {
      prop: 'createTime',
      label: '入库时间',
      width: '200'
    },{
      prop: 'bleName',
      label: '广播name',
      width: '150'
    },{
      prop: 'bleRssi',
      label: 'RSSI值',
      width: '150'
    },{
      prop: 'bikeId',
      label: '车辆编号',
      width: '150'
    }, {
      prop: 'brandName',
      label: '车企',
      width: '150'
    }, {
      prop: 'matchTime',
      label: '最终匹配时间',
      width: '200'
    }, {
      fix: 'right',
      label: '操作',
      width: '150'
    }]
  },
  // 考勤站点列表
  clockSiteList: {
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'brandName',
      label: '品牌名称',
      width: '100'
    }, {
      prop: 'clockSiteName',
      label: '考勤站点名称',
      width: '200'
    }, {
      prop: 'clockSiteLon',
      label: '考勤点经度',
      width: '120'
    }, {
      prop: 'clockSiteLat',
      label: '考勤点纬度',
      width: '120'
    }, {
      prop: 'createName',
      label: '创建者',
      width: '100'
    }, {
      prop: 'createTime',
      label: '创建时间',
      width: '120'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  }, // 考勤统计
  clock_statistics_day: {
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'name',
      label: '用户名',
      width: '100'
    }, {
      prop: 'brandName',
      label: '品牌',
      width: '100'
    }, {
      prop: 'startTime',
      label: '上班打卡时间',
      width: '120'
    }, {
      prop: 'startSite',
      label: '上班打卡地点',
      width: '200'
    }, {
      prop: 'endTime',
      label: '下班打卡时间',
      width: '120'
    }, {
      prop: 'endSite',
      label: '下班打卡地点',
      width: '200'
    }, {
      prop: 'createTime',
      label: '创建时间',
      width: '120'
    }]
  }, // 考勤统计
  clock_statistics_month: {
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'monthDate',
      label: '月份',
      width: '100'
    }, {
      prop: 'name',
      label: '用户名',
      width: '100'
    }, {
      prop: 'brandName',
      label: '品牌',
      width: '100'
    }, {
      prop: 'avgWorkHours',
      label: '平均工时',
      width: '100'
    }, {
      prop: 'workDays',
      label: '出勤天数',
      width: '100'
    }, {
      prop: 'loseCardNums',
      label: '缺卡次数',
      width: '100'
    }]
  }, // 考勤统计用户考勤打卡明细
  user_clock_info: {
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'name',
      label: '用户名',
      width: '100'
    }, {
      prop: 'monthDate',
      label: '月份',
      width: '100'
    }, {
      prop: 'brandName',
      label: '品牌名称',
      width: '100'
    }, {
      prop: 'sumWorkHours',
      label: '平均工时',
      width: '100'
    }, {
      prop: 'startTime',
      label: '上班打卡时间',
      width: '120'
    }, {
      prop: 'startSite',
      label: '上班打卡地点',
      width: '200'
    }, {
      prop: 'endTime',
      label: '下班打卡时间',
      width: '120'
    }, {
      prop: 'endSite',
      label: '下班打卡地点',
      width: '200'
    }, {
      prop: 'createTime',
      label: '创建时间',
      width: '120'
    }]
  },
  // 轨迹回放列表
  track_play_back: {
    columns: [{
      prop: 'index',
      label: '序号',
      width: '50'
    }, {
      prop: 'name',
      label: '姓名',
      width: '100'
    }, {
      prop: 'brandName',
      label: '品牌名称',
      width: '100'
    }, {
      prop: 'areaName',
      label: '区域',
      width: '100'
    }, {
      prop: 'date',
      label: '日期',
      width: '120'
    }, {
      fix: 'right',
      label: '操作',
      width: '100'
    }]
  }
}

export default data
